import React from 'react';
import './Navbar.css';

function Navbar({ onSavePlan, onLoadPlans }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h1>🧪 FitPrep</h1>
          <p>Smart fitness planning</p>
        </div>
        <div className="navbar-actions">
          <button onClick={onLoadPlans} className="btn-secondary">
            📋 My Plans
          </button>
          <button onClick={onSavePlan} className="btn-primary">
            💾 Save Current Plan
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;


